import { useQuery } from 'react-query';
import { TransactionService } from '../../services/wealthlane-award-services';

const useGetTaxDetailsForVendorByTransactionId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId: string,
  transactionId: string,
  setInitialValue?: any
) => {
  const taxDetail = useQuery(
    ['getTaxDetailsForVendorByTransactionId', companyId, transactionId],
    async () => {
      if (!companyId || !transactionId) return undefined;
      return await handleRequest(
        TransactionService.getApiAwardApiAppTransactionTaxDetailsForVendorByTransactionId(
          companyId,
          transactionId
        )
      );
    },
    {
      enabled: !!companyId && !!transactionId,
      onSuccess: (response: any) => {
        if (response != null) {
          setInitialValue?.(response);
        }
      },
      onError: (err: any) => {
        console.log('error', err);
      },
    }
  );
  return taxDetail;
};

export default useGetTaxDetailsForVendorByTransactionId;
